module.exports = __webpack_public_path__ + "static/media/JS.61548008.svg";